import React from "react";
import Banner from "../../components/Banner/Banner";
import { CheckCircleOutlineOutlined } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { learnLearningPathListView } from "../../routes/LearningCenterRoutes";

const linkToAssignmentsList = React.forwardRef((props, ref) => (
  <RouterLink innerRef={ref} to={learnLearningPathListView} {...props} />
));

const useStyles = makeStyles(theme => ({
  header: {
    fontSize: "3rem",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem"
    }
  },
  checkmark: {
    width: "12%",
    maxWidth: 88,
    height: 88,
    marginRight: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      width: 44,
      height: 44,
      marginRight: theme.spacing(2)
    }
  }
}));

export default function LearningPathNoAssignmentsView({
  showViewAllAssignmentsButton
}) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Box height={480} mb={4}>
      <Banner gradientDirection="rtl" ellipseBackground="right">
        <Box
          display="flex"
          height="100%"
          alignItems="center"
          pl={{ xs: 2, sm: 3, md: 11.5 }}
          pr={2}
        >
          <Box display="flex">
            <CheckCircleOutlineOutlined
              color="secondary"
              className={classes.checkmark}
            />
            <Box
              display="flex"
              flexDirection="column"
              color="white"
              maxWidth={486}
              alignItems="flex-start"
            >
              <Typography className={classes.header}>
                Congratulations!
              </Typography>
              <Typography variant="h5">
                You are all caught up with your assignments. You are well on
                your way on your learning path.
              </Typography>
              {showViewAllAssignmentsButton && (
                <Button
                  variant="contained"
                  color="primary"
                  component={linkToAssignmentsList}
                  sx={{ mt: 4 }}
                >
                  {t("learningPathAssignments.viewAllMyAssignmentsButton")}
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Banner>
    </Box>
  );
}
